import { Component, inject } from '@angular/core';
import { EdiDispatchAdvicesListConfigService } from '../../../services/edi-dispatch-advices-list-config/edi-dispatch-advices-list-config.service';

@Component({
    selector: 'lib-edi-dispatch-advices',
    template: `<lib-edi-list-wrapper
      [configService]="configService"
      title="EDI - Despatch advice">
    </lib-edi-list-wrapper>`,
    styleUrls: ['./edi-dispatch-advices.component.css'],
    standalone: false
})
export class EdiDispatchAdvicesComponent {
  public configService = inject(EdiDispatchAdvicesListConfigService);
}
